import { createFileRoute } from "@tanstack/react-router";
import { EMPTY_ORG_ID } from "@/constants/org";
import { AssetTypeLifecycleSection } from "@/utils/asset-type-detail/asset-type-lifecycle-section";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/configuration/assetTypes/$assetTypeId/lifecycle",
)({
	component: AdminAssetTypeLifecycleTab,
});

function AdminAssetTypeLifecycleTab() {
	return (
		<div className="px-5 pb-5">
			<AssetTypeLifecycleSection
				organizationId={EMPTY_ORG_ID}
				variant="drawer"
			/>
		</div>
	);
}
